import { useAppSelector } from '@frontend/common';
import { listStore, refresh } from '@frontend/repository';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../../../../app/redux/store';
import { StockDetailProps } from './stock-detail.component';

export const useStockDetail = (props: StockDetailProps) => {
    const dispatch = useAppDispatch();
    const list = useAppSelector(useSelector, listStore);
    const stockList = list['stock-detail-stock-list'];

    const [spot, setSpot] = useState<string | null>(null);
    useEffect(() => {
        if (!stockList) return;
        dispatch(refresh({ listId: 'stock-detail-stock-list', refresh: true }));
    }, [props.product, spot]);

    return {
        stockList,
        spot,
        setSpot,
        dispatch
    };
};
